/*!
=========================================================
* Vision UI Free React - v1.0.0
=========================================================
*/

// Vision UI Dashboard React base styles
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Vision UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;
const { white, primary } = colors;

export default {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      textAlign: "center",
      maxWidth: "unset !important",
      minWidth: "150px",
      minHeight: "35px",
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textTransform: "none",
      lineHeight: "inherit",
      padding: `${pxToRem(10)} !important`,
      borderRadius: borderRadius.md,

      // Inactive tab
      color: `${primary.main} !important`,
      opacity: "1 !important",

      "& .material-icons, & .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(4),
        color: `${primary.main} !important`,
      },

      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
        color: `${primary.main} !important`,
      },

      // Active tab
      "&.Mui-selected": {
        color: `${white.main} !important`,

        "& .material-icons, & .material-icons-round": {
          color: `${white.main} !important`,
        },

        "& svg": {
          color: `${white.main} !important`,
        },
      },
    },

    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};
